import {
    CarFront,
    ArrowDownCircle,
    ArrowUpCircle,
    Activity
} from "lucide-react";

export default function FacilityStats({
    currentVehicles = 0,
    totalEntries = 0,
    totalExits = 0
}) {

    // =========================================
    // STATS CONFIG
    // =========================================

    const stats = [

        {
            title: "Current Vehicles",
            value: currentVehicles,
            icon: CarFront,
            bg: "bg-blue-100",
            text: "text-blue-700",
            border: "border-blue-200"
        },

        {
            title: "Entries Today",
            value: totalEntries,
            icon: ArrowDownCircle,
            bg: "bg-green-100",
            text: "text-green-700",
            border: "border-green-200"
        },

        {
            title: "Exits Today",
            value: totalExits,
            icon: ArrowUpCircle,
            bg: "bg-red-100",
            text: "text-red-700",
            border: "border-red-200"
        }

    ];

    return (

        <div className="
            px-6
            py-4
            grid
            grid-cols-1
            md:grid-cols-3
            gap-4
            shrink-0
        ">

            {stats.map((stat, index) => {

                const Icon = stat.icon;

                return (

                    <div
                        key={index}
                        className={`
                            relative
                            overflow-hidden
                            rounded-2xl
                            border
                            shadow-sm
                            bg-white
                            p-5
                            ${stat.border}
                        `}
                    >

                        {/* ============================= */}
                        {/* BACKGROUND DECORATION */}
                        {/* ============================= */}

                        <div className={`
                            absolute
                            -right-6
                            -top-6
                            w-24
                            h-24
                            rounded-full
                            opacity-20
                            ${stat.bg}
                        `} />

                        {/* ============================= */}
                        {/* CONTENT */}
                        {/* ============================= */}

                        <div className="
                            relative
                            z-10
                            flex
                            items-center
                            justify-between
                        ">

                            {/* LEFT SIDE */}

                            <div>

                                <p className="
                                    text-sm
                                    font-medium
                                    text-gray-500
                                    mb-2
                                ">
                                    {stat.title}
                                </p>

                                <h2 className={`
                                    text-4xl
                                    font-bold
                                    ${stat.text}
                                `}>
                                    {stat.value}
                                </h2>

                            </div>

                            {/* RIGHT SIDE */}

                            <div className={`
                                p-4
                                rounded-2xl
                                ${stat.bg}
                            `}>

                                <Icon
                                    size={30}
                                    className={stat.text}
                                />

                            </div>

                        </div>

                    </div>
                );
            })}

            {/* ================================= */}
            {/* LIVE ACTIVITY INDICATOR */}
            {/* ================================= */}

            <div className="
                md:col-span-3
                flex
                items-center
                justify-end
                gap-3
                mt-2
                pr-1
            ">

                <div className="
                    flex
                    items-center
                    gap-2
                    bg-white
                    px-4
                    py-2
                    rounded-full
                    border
                    border-gray-200
                    shadow-sm
                ">

                    <div className="
                        w-3
                        h-3
                        rounded-full
                        bg-green-500
                        animate-pulse
                    " />

                    <div className="
                        flex
                        items-center
                        gap-2
                    ">

                        <Activity
                            size={16}
                            className="text-green-600"
                        />

                        <span className="
                            text-sm
                            font-semibold
                            text-green-700
                        ">
                            Real-Time Monitoring Active
                        </span>

                    </div>

                </div>

            </div>

        </div>
    );
}